import React, { Fragment, useState, useEffect } from 'react'
import { Box, Button, CardMedia, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, IconButton, InputLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import Colors from '../../../Assets/Styles/Colors'
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs'
import { baseUrl } from '../../../../axios'
import { DeleteForever, KeyboardArrowLeft, DriveFolderUpload, PhotoLibrary, Close, Publish, Photo } from '@mui/icons-material'
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices'
import BannerServices from '../../../Api/Banner/BannerServices'
import { PrimaryButton, SecondaryButton } from '../../../Components/Buttons'
import { ErrorToaster, SuccessToaster } from '../../../Components/Toaster/Toaster'
import { useNavigate } from 'react-router-dom'
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog'
import { InputField } from '../../../Components/Fields/TextFields'
import { useForm } from 'react-hook-form'
import SelectField from '../../../Components/Fields/SelectField'
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import AddressForm from '../../../Components/AddressForm'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import AdleaksServices from '../../../Api/AdLeak/AdleaksServices'
import SimpleDialog from '../../../Components/Dialogs/SimpleDialog'

const eventTypes = [
  {
    _id: "001",
    name: "Dragons Of Pakistan",
    value: "dragons"
  },
  {
    _id: "002",
    name: "Advision",
    value: "advision"
  },
  {
    _id: "003",
    name: "Other",
    value: "other"
  },
  {
    _id: "004",
    name: "Third Party",
    value: "third_party"
  },
];

const featuredTypes = [
  {
    id: "001",
    name: "Admeet",
    value: "admeet"
  },
  {
    id: "002",
    name: "Adread",
    value: "adread"
  },
  {
    id: "003",
    name: "Adbook",
    value: "adbook"
  },
  {
    id: "004",
    name: "Adguru",
    value: "adguru"
  },
  {
    id: "005",
    name: "Adpro",
    value: "adpro"
  },
];

function UploadHomeBanner() {
  const [image, setImage] = useState("");
  const [formImage, setFormImage] = useState("");
  const [emailLogo, setEmailLogo] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedFeatured, setSelectedFeatured] = useState(null);
  const [featured, setFeatured] = useState(null);
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [dragonsTableDialogOpen, setDragonsTableDialogOpen] = useState(false);
  const [dragonsSeatDialogOpen, setDragonsSeatDialogOpen] = useState(false);
  const [advisionSeatDialogOpen, setAdvisionSeatDialogOpen] = useState(false);
  const [dragonsTables, setDragonsTable] = useState([{ dTableCategoryName: "", price: "" }])
  const [dragonsTablesCategories, setDragonsTablesCategories] = useState([])
  const [dragonsSeats, setDragonsSeats] = useState([{ dSeatCategoryName: "", price: "" }])
  const [dragonsSeatsCategories, setDragonsSeatsCategories] = useState([])
  const [advisionSeats, setAdvisionSeats] = useState([{ aSeatCategoryName: "", price: "" }])
  const [advisionSeatsCategories, setAdvisionSeatsCategories] = useState([])
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const [type, setType] = useState("event");
  const [eventName, setEventName] = useState("");
  const [hasPass, setHasPass] = useState("yes");
  const [ckValue, setCkValue] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, reset, setValue, } = useForm();
  const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, reset: reset1, getValues: getValues1, } = useForm();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2, getValues: getValues2, } = useForm();
  const { register: register3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, reset: reset3, getValues: getValues3, } = useForm();

  const handleFileUpload = async (file, from) => {
    const formData = new FormData();
    formData.append("image", file);

    const getDimensions = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => resolve({ width: img.width, height: img.height });
          img.onerror = reject;
          img.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };

    const dimensions = await getDimensions(file);

    const width = 647;
    const height = 340;

    if (from == "emailLogo") {
      if (dimensions.width != width && dimensions.height != height) {
        ErrorToaster(`Email logo width should be ${width}px and height should be ${height}px`);
      } else if (dimensions.width != width) {
        ErrorToaster(`Email logo width should be ${width}px`);
      } else if (dimensions.height != height) {
        ErrorToaster(`Email logo height should be ${height}px`);
      } else {
        try {
          const result = await CategoriesServices.uploadImage(formData);
          if (result.responseCode == 200) {
            setEmailLogo(result?.data?.imageUrl)
          }
        } catch (error) {
          console.log(error)
        }
      }
    } else {
      try {
        const result = await CategoriesServices.uploadImage(formData);
        if (result.responseCode == 200) {
          if (from == "bannerImage") {
            setImage(result?.data?.imageUrl)
          } else if (from == "formImage") {
            setFormImage(result?.data?.imageUrl)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  };

  const bannerImage = async (formData) => {
    setLoading(true);
    const obj = {
      imageUrl: image,
      formImg: formImage,
      type: "home",
      url: formData.url,
      blogId: selectedBlog?.id || null,
      eventName: eventName,
      eventDate: selectedEvent.value != "third_party" ? moment(selectedDate).format("DD/MM/YYYY") : null,
      eventStartTime: selectedEvent.value != "third_party" ? moment(startTime).format("hh:mm A") : null,
      eventEndTime: selectedEvent.value != "third_party" ? moment(endTime).format("hh:mm A") : null,
      venue: addressData?.address,
      mailBody: ckValue,
      price: selectedEvent.value == "other" ? +formData.passPrice : null,
      table: selectedEvent.value == "dragons" ? dragonsTablesCategories : null,
      seat: selectedEvent.value == "dragons" ? dragonsSeatsCategories : selectedEvent.value == "advision" ? advisionSeatsCategories : null,
      logo: baseUrl + emailLogo,
    };
    try {
      const result = await BannerServices.createBanner(obj);
      if (result.responseCode == 200) {
        SuccessToaster(result.message);
        setImage("");
        setFormImage("");
        reset();
        setSelectedEvent(null);
        setAddressData(null);
        setSelectedDate(null);
        setStartTime(null);
        setEndTime(null);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = moment(date).toDate();
    setSelectedDate(formattedDate);
  };

  const handleStartTimeChange = (time) => {
    const formattedTime = moment(time)
    setStartTime(formattedTime);
  };

  const handleEndTimeChange = (time) => {
    const formattedTime = moment(time)
    setEndTime(formattedTime);
  };

  const saveAddress = async (data) => {
    try {
      setAddressDialogOpen(false);
      setAddressData(data);
      setValue("address", data?.address);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDragonTableDialog = () => setDragonsTableDialogOpen((prevOpen) => !prevOpen);
  const handleDragonSeatDialog = () => setDragonsSeatDialogOpen((prevOpen) => !prevOpen);
  const handleAdvisionSeatDialog = () => setAdvisionSeatDialogOpen((prevOpen) => !prevOpen);

  const handleSetState = (id, name, value, from) => {
    if (from == "event") {
      setSelectedEvent({ id: id, name: name, value, value });
      if (value == "dragons") {
        setEventName(name);
      } else if (value == "advision") {
        setEventName(name);
      } else {
        setEventName("");
      }
    } else if (from == "feature") {
      setSelectedFeatured({ id: id, name: name, value, value });
      setEventName(value);
      getAllBlogs(value);
    }
  };

  const handleEditorChange = (event, editor) => {
    setCkValue(editor.getData());
  };

  const submitTableForm = () => {
    const data = dragonsTables.map((item, index) => ({
      category: getValues1(`dTableCategoryName${index}`),
      price: getValues1(`price${index}`),
    }));
    setDragonsTablesCategories(data);
    handleDragonTableDialog();
  };

  const submitSeatForm = () => {
    const data = dragonsSeats.map((item, index) => ({
      category: getValues2(`dSeatCategoryName${index}`),
      price: getValues2(`price${index}`),
    }));
    setDragonsSeatsCategories(data);
    handleDragonSeatDialog();
  };

  const submitSeatFormAdvision = () => {
    const data = advisionSeats.map((item, index) => ({
      category: getValues3(`aSeatCategoryName${index}`),
      price: getValues3(`price${index}`),
    }));
    setAdvisionSeatsCategories(data);
    handleAdvisionSeatDialog();
  };

  const getAllBlogs = async (type) => {
    try {
      const result = await AdleaksServices.getAllAdLeaks(
        "",
        "",
        1,
        25,
        type,
        true
      )
      if (result.responseCode == 200) {
        const arrOfObj = result?.data?.blogs?.map((item) => ({ _id: item?._id, name: item?.title }));
        setBlogs(arrOfObj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
      <AddressForm open={addressDialogOpen} onClose={() => setAddressDialogOpen(false)} save={(data) => saveAddress(data)} />
      <SimpleDialog open={dragonsTableDialogOpen} onClose={handleDragonTableDialog} maxWidth={"md"} fullWidth={true} title={"Dragons Table Categories & Prices"}>
        <Grid container spacing={2} component={"form"} onSubmit={handleSubmit1(submitTableForm)}>
          {dragonsTables.map((item, index) => (
            <Grid item md={12} key={index}>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <InputField
                    label={"Category Name"}
                    register={register1(`dTableCategoryName${index}`, {
                      required: "Please enter table category name"
                    })}
                    error={errors1[`dTableCategoryName${index}`] && true}
                    helperText={errors1[`dTableCategoryName${index}`]?.message}
                  />
                </Grid>
                <Grid item md={6}>
                  <InputField
                    label={"Price"}
                    register={register1(`price${index}`, {
                      required: "Please enter table price"
                    })}
                    error={errors1[`price${index}`] && true}
                    helperText={errors1[`price${index}`]?.message}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Button
                  variant={"outlined"}
                  fullWidth
                  sx={{
                    border: `2px solid ${Colors.primary}`,
                    borderRadius: "4px",
                    textTransform: "capitalize",
                    ":hover": {
                      border: `2px solid transparent`,
                      background: Colors.primary,
                      color: Colors.white
                    }
                  }}
                  onClick={() => setDragonsTable([...dragonsTables, { dTableCategoryName: "", price: "" }])}
                >
                  Add More
                </Button>
              </Grid>
              <Grid item md={6}>
                <SecondaryButton
                  fullWidth={true}
                  title={"Submit"}
                  type={"submit"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleDialog>
      <SimpleDialog open={dragonsSeatDialogOpen} onClose={handleDragonSeatDialog} maxWidth={"md"} fullWidth={true} title={"Dragons Seat Categories & Prices"}>
        <Grid container spacing={2} component={"form"} onSubmit={handleSubmit2(submitSeatForm)}>
          {dragonsSeats.map((item, index) => (
            <Grid item md={12} key={index}>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <InputField
                    label={"Category Name"}
                    register={register2(`dSeatCategoryName${index}`, {
                      required: "Please enter seat category name"
                    })}
                    error={errors2[`dSeatCategoryName${index}`] && true}
                    helperText={errors2[`dSeatCategoryName${index}`]?.message}
                  />
                </Grid>
                <Grid item md={6}>
                  <InputField
                    label={"Price"}
                    register={register2(`price${index}`, {
                      required: "Please enter seat price"
                    })}
                    error={errors2[`price${index}`] && true}
                    helperText={errors2[`price${index}`]?.message}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Button
                  variant={"outlined"}
                  fullWidth
                  sx={{
                    border: `2px solid ${Colors.primary}`,
                    borderRadius: "4px",
                    textTransform: "capitalize",
                    ":hover": {
                      border: `2px solid transparent`,
                      background: Colors.primary,
                      color: Colors.white
                    }
                  }}
                  onClick={() => setDragonsSeats([...dragonsSeats, { dSeatCategoryName: "", price: "" }])}
                >
                  Add More
                </Button>
              </Grid>
              <Grid item md={6}>
                <SecondaryButton
                  fullWidth={true}
                  title={"Submit"}
                  type={"submit"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleDialog>
      <SimpleDialog open={advisionSeatDialogOpen} onClose={handleAdvisionSeatDialog} maxWidth={"md"} fullWidth={true} title={"Advision Seat Categories & Prices"}>
        <Grid container spacing={2} component={"form"} onSubmit={handleSubmit3(submitSeatFormAdvision)}>
          {advisionSeats.map((item, index) => (
            <Grid item md={12} key={index}>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <InputField
                    label={"Category Name"}
                    register={register3(`aSeatCategoryName${index}`, {
                      required: "Please enter seat category name"
                    })}
                    error={errors3[`aSeatCategoryName${index}`] && true}
                    helperText={errors3[`aSeatCategoryName${index}`]?.message}
                  />
                </Grid>
                <Grid item md={6}>
                  <InputField
                    label={"Price"}
                    register={register3(`price${index}`, {
                      required: "Please enter seat price"
                    })}
                    error={errors3[`price${index}`] && true}
                    helperText={errors3[`price${index}`]?.message}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Button
                  variant={"outlined"}
                  fullWidth
                  sx={{
                    border: `2px solid ${Colors.primary}`,
                    borderRadius: "4px",
                    textTransform: "capitalize",
                    ":hover": {
                      border: `2px solid transparent`,
                      background: Colors.primary,
                      color: Colors.white
                    }
                  }}
                  onClick={() => setAdvisionSeats([...advisionSeats, { aSeatCategoryName: "", price: "" }])}
                >
                  Add More
                </Button>
              </Grid>
              <Grid item md={6}>
                <SecondaryButton
                  fullWidth={true}
                  title={"Submit"}
                  type={"submit"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleDialog>
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Create Event
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Create Event"]} />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          }}
        >
          <Grid container spacing={2} sx={{ mt: "20px" }}>
            <Grid item md={12}>
              <Grid container spacing={2} alignItems={"center"} component={"form"} onSubmit={handleSubmit(bannerImage)}>
                <Grid item md={12}>
                  <Box
                    sx={{
                      mb: errors?.image ? 2 : 0,
                      height: image !== "" ? "100%" : "400px",
                      border: image !== "" ? "none" : errors?.image ? "1px solid #f44336" : "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "4px",
                      ":hover": {
                        borderColor: image !== "" ? "transparent" : errors?.image ? "#f44336" : "#1F1F1F"
                      },
                      backgroundColor: Colors.white,
                    }}
                  >
                    {image !== "" ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center"
                        }}
                      >
                        <CardMedia
                          component={"img"}
                          src={baseUrl + image}
                          sx={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover"
                          }}
                        />
                      </Box>
                    ) : (
                      <Fragment>
                        <InputLabel
                          error={errors?.image && true}
                          htmlFor="image-input"
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px"
                          }}
                        >
                          <PhotoLibrary sx={{ fontSize: "36px" }} />
                          <Typography>
                            Upload Image
                          </Typography>
                        </InputLabel>
                        <input
                          {...register("image", {
                            required: "Please upload an image"
                          })}
                          id="image-input"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleFileUpload(e.target.files[0], "bannerImage")}
                          style={{ display: "none" }}
                        />
                        <FormHelperText error={errors?.image && true}>
                          {errors?.image?.message}
                        </FormHelperText>
                      </Fragment>
                    )}
                  </Box>
                </Grid>
                <Grid item md={6}>
                  <Box>
                    <SelectField
                      data={eventTypes}
                      stateValue={selectedEvent?.name}
                      setState={(id, name, value) => handleSetState(id, name, value, "event")}
                      label={"Event Type"}
                      register={register("event", {
                        required: "Pelase select a event",
                      })}
                      error={errors?.event?.message}
                    />
                  </Box>
                </Grid>
                {selectedEvent?.value == "other" && (
                  <Fragment>
                    <Grid item md={featured ? 4.5 : 4.8}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <FormControl sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", gap: 2, width: "100%" }}>
                          <Typography>This is an event or announcement?</Typography>
                          <RadioGroup
                            row
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          >
                            <FormControlLabel value="event" control={<Radio />} label="Event" />
                            <FormControlLabel value="announcement" control={<Radio />} label="Announcement" />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item md={featured ? 1.5 : 1.2}>
                      <Box>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ flexDirection: "row-reverse", justifyContent: "space-between", m: 0 }}
                            control={
                              <Checkbox onChange={(e) => {
                                if (!e.target.checked) {
                                  setEventName("");
                                }
                                if (e.target.checked) {
                                  setSelectedFeatured(null);
                                }
                                setFeatured(e.target.checked)
                              }}
                              />
                            }
                            label={`${featured ? "Unfeature" : "Feature"} this?`} />
                        </FormGroup>
                      </Box>
                    </Grid>
                  </Fragment>
                )}
                {selectedEvent && (
                  selectedEvent?.value == "third_party" ? (
                    <Grid item md={6}>
                      <InputField
                        label={"Enter URL"}
                        register={register("url", {
                          required: "Please enter an url"
                        })}
                        error={errors?.url?.message}
                        helperText={errors?.url?.message}
                      />
                    </Grid>
                  ) : (selectedEvent?.value == "other" && type == "announcement") ? (
                    <Fragment>
                      {featured && (
                        <Fragment>
                          <Grid item md={6}>
                            <Box>
                              <SelectField
                                data={featuredTypes}
                                stateValue={selectedFeatured?.name}
                                setState={(id, name, value) => handleSetState(id, name, value, "feature")}
                                label={"Featured Type"}
                                register={register("featuredType", {
                                  required: "Please select featured Type"
                                })}
                                error={errors?.featuredType?.message}
                                helperText={errors?.featuredType?.message}
                              />
                            </Box>
                          </Grid>
                          <Grid item md={6}>
                            <Box>
                              <SelectField
                                data={blogs}
                                stateValue={selectedBlog?.name}
                                setState={(id, name) => setSelectedBlog({ id, name })}
                                label={"Featured for"}
                                register={register("featuredFor", {
                                  required: "Please select featured for"
                                })}
                                error={errors?.featuredFor?.message}
                                helperText={errors?.featuredFor?.message}
                              />
                            </Box>
                          </Grid>
                        </Fragment>
                      )}
                      <Grid item md={type == "announcement" ? 12 : 6}>
                        <Box>
                          <InputField
                            label={"Enter URL"}
                            register={register("url", {
                              required: "Please enter an url"
                            })}
                            error={errors?.url?.message}
                            helperText={errors?.url?.message}
                          />
                        </Box>
                      </Grid>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {selectedEvent?.value == "other" && featured && (
                        <Fragment>
                          <Grid item md={6}>
                            <Box>
                              <SelectField
                                data={featuredTypes}
                                stateValue={selectedFeatured?.name}
                                setState={(id, name, value) => handleSetState(id, name, value, "feature")}
                                label={"Featured Type"}
                                register={register("featuredType", {
                                  required: "Please select featured Type"
                                })}
                                error={errors?.featuredType?.message}
                                helperText={errors?.featuredType?.message}
                              />
                            </Box>
                          </Grid>
                          <Grid item md={6}>
                            <Box>
                              <SelectField
                                data={blogs}
                                stateValue={selectedBlog?.name}
                                setState={(id, name) => setSelectedBlog({ id, name })}
                                label={"Featured for"}
                                register={register("featuredFor", {
                                  required: "Please select featured for"
                                })}
                                error={errors?.featuredFor?.message}
                                helperText={errors?.featuredFor?.message}
                              />
                            </Box>
                          </Grid>
                        </Fragment>
                      )}
                      <Grid item md={6}>
                        <Box>
                          <InputField
                            InputProps={{ readOnly: selectedFeatured != null ? true : false }}
                            value={eventName}
                            onChange={(e) => setEventName(e.target.value)}
                            disable={selectedEvent?.value == "other" ? false : true}
                            label={"Name"}
                            register={register("eventName", {
                              required: eventName == "" ? "Please enter a name" : false,
                            })}
                            error={errors?.eventName?.message}
                            helperText={errors?.eventName?.message}
                          />
                        </Box>
                      </Grid>
                      {/* <Grid item md={selectedEvent.value == "dragons" || selectedEvent.value == "advision" ? 12 : 6}> */}
                      <Grid item md={6}>
                        <Box>
                          <TextField
                            {...register("address", {
                              required: "Please select a location"
                            })}
                            onClick={() => setAddressDialogOpen(true)}
                            fullWidth
                            label={addressData?.address ? null : "Address"}
                            InputProps={{ readOnly: true }}
                            value={addressData?.address}
                            error={errors?.address && true}
                            helperText={errors?.address?.message}
                            sx={{
                              "& .MuiFormHelperText-root": {
                                mx: "0 !important"
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6}>
                        <Grid container spacing={2} alignItems={"flex-end"}>
                          <Grid item md={6}>
                            <Box>
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                  {...register("date", {
                                    required: selectedDate == null ? "Please select a date" : false
                                  })}
                                  label="Select Date"
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: errors?.date && true,
                                      helperText: errors?.date?.message,
                                      sx: {
                                        "& .MuiFormHelperText-root": {
                                          mx: "0 !important"
                                        }
                                      }
                                    }
                                  }}

                                  onChange={(date) => handleDateChange(date)}
                                />
                              </LocalizationProvider>
                            </Box>
                          </Grid>
                          <Grid item md={3}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <TimePicker
                                {...register("startTime", {
                                  // required: startTime == null ? "Start time" : false
                                })}
                                ampm={false}
                                label="Start Time"
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: errors?.startTime && true,
                                    helperText: errors?.startTime?.message,
                                    sx: {
                                      "& .MuiFormHelperText-root": {
                                        mx: "0 !important"
                                      }
                                    }
                                  }
                                }}
                                onChange={(time) => handleStartTimeChange(time)}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item md={3}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <TimePicker
                                {...register("endTime", {
                                  // required: endTime == null ? "End time" : false
                                })}
                                ampm={false}
                                label="End Time"
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: errors?.endTime && true,
                                    helperText: errors?.endTime?.message,
                                    sx: {
                                      "& .MuiFormHelperText-root": {
                                        mx: "0 !important"
                                      }
                                    }
                                  }
                                }}
                                onChange={(time) => handleEndTimeChange(time)}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                      {selectedEvent?.value == "other" && (
                        <Fragment>
                          <Grid item md={6}>
                            <Grid container spacing={2} alignItems={"center"}>
                              <Grid item md={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <FormControl sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", gap: 2, width: "100%" }}>
                                    <Typography>Do the event contain passes?</Typography>
                                    <RadioGroup
                                      row
                                      value={hasPass}
                                      onChange={(e) => setHasPass(e.target.value)}
                                    >
                                      <FormControlLabel value={"yes"} control={<Radio />} label="Yes" />
                                      <FormControlLabel value={"no"} control={<Radio />} label="No" />
                                    </RadioGroup>
                                  </FormControl>
                                </Box>
                              </Grid>
                              {selectedEvent?.value == "other" && hasPass == "yes" && (
                                <Grid item md={6}>
                                  <Box>
                                    <InputField
                                      label={"Pass Price"}
                                      register={register("passPrice", {
                                        required: "Please enter pass price"
                                      })}
                                      error={errors?.passPrice?.message}
                                      helperText={errors?.passPrice?.message}
                                    />
                                  </Box>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </Fragment>
                      )}
                      {!featured && selectedEvent?.value == "dragons" ? (
                        <Grid item md={6}>
                          <Grid container spacing={2}>
                            <Grid item md={6}>
                              <Button
                                variant='outlined'
                                fullWidth
                                sx={{
                                  border: `2px solid ${Colors.primary}`,
                                  borderRadius: "4px",
                                  p: "8px 16px",
                                  fontSize: "16px",
                                  textTransform: "capitalize",
                                  ":hover": {
                                    border: `2px solid transparent`,
                                    background: Colors.primary,
                                    color: Colors.white
                                  }
                                }}
                                onClick={handleDragonTableDialog}
                              >
                                Edit Table Categories & Prices
                              </Button>
                            </Grid>
                            <Grid item md={6}>
                              <Button
                                variant='outlined'
                                fullWidth
                                sx={{
                                  border: `2px solid ${Colors.primary}`,
                                  borderRadius: "4px",
                                  p: "8px 16px",
                                  fontSize: "16px",
                                  textTransform: "capitalize",
                                  ":hover": {
                                    border: `2px solid transparent`,
                                    background: Colors.primary,
                                    color: Colors.white
                                  }
                                }}
                                onClick={handleDragonSeatDialog}
                              >
                                Edit Seat Categories & Prices
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : !featured && selectedEvent?.value == "advision" ? (
                        <Grid item md={6}>
                          <Button
                            variant='outlined'
                            fullWidth
                            sx={{
                              border: `2px solid ${Colors.primary}`,
                              borderRadius: "4px",
                              p: "8px 16px",
                              fontSize: "16px",
                              textTransform: "capitalize",
                              ":hover": {
                                border: `2px solid transparent`,
                                background: Colors.primary,
                                color: Colors.white
                              }
                            }}
                            onClick={handleAdvisionSeatDialog}
                          >
                            Edit Seat Categories & Prices
                          </Button>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {!featured && (
                        <Grid item md={6}>
                          <Grid container spacing={2}>
                            <Grid item md={6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between"
                                }}
                              >
                                {formImage == "" ? (
                                  <Fragment>
                                    <input
                                      {...register("formImage", {
                                        required: "Please upload form image"
                                      })}
                                      accept="image/*"
                                      id="upload-button-file"
                                      type="file"
                                      style={{ display: "none" }}
                                      onChange={(e) => handleFileUpload(e.target.files[0], "formImage")}
                                    />

                                    {/* Icon button */}
                                    <label htmlFor="upload-button-file" style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} >
                                      <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        sx={{
                                          background: Colors.primary,
                                          border: `1px solid transparent`,
                                          ":hover": {
                                            border: `1px solid ${Colors.primary}`,
                                            background: Colors.white,
                                            borderColor: Colors.primary,
                                            "svg": {
                                              color: Colors.primary
                                            }
                                          }
                                        }}
                                      >
                                        <Photo sx={{ fontSize: "24px", color: Colors.white }} />
                                      </IconButton>
                                      <Typography>Upload Form Image</Typography>
                                    </label>
                                  </Fragment>
                                ) : (
                                  <Fragment>
                                    <Box
                                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                    >
                                      <IconButton onClick={() => setFormImage("")}><Close /></IconButton>
                                      <Typography>{formImage}</Typography>
                                    </Box>
                                  </Fragment>
                                )}
                              </Box>
                              <FormHelperText sx={{ display: errors?.formImage ? "block" : "none" }} error={errors?.formImage && true}>{errors?.formImage?.message}</FormHelperText>
                            </Grid>
                            <Grid item md={6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between"
                                }}
                              >
                                {emailLogo == "" ? (
                                  <Fragment>
                                    <input
                                      {...register("emailLogo", {
                                        required: "Please upload logo for email"
                                      })}
                                      accept="image/*"
                                      id="upload-button-logo"
                                      type="file"
                                      style={{ display: "none" }}
                                      onChange={(e) => handleFileUpload(e.target.files[0], "emailLogo")}
                                    />

                                    {/* Icon button */}
                                    <label htmlFor="upload-button-logo" style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} >
                                      <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        sx={{
                                          background: Colors.primary,
                                          border: `1px solid transparent`,
                                          ":hover": {
                                            border: `1px solid ${Colors.primary}`,
                                            background: Colors.white,
                                            borderColor: Colors.primary,
                                            "svg": {
                                              color: Colors.primary
                                            }
                                          }
                                        }}
                                      >
                                        <Publish sx={{ fontSize: "24px", color: Colors.white }} />
                                      </IconButton>
                                      <Typography>Upload Email Logo</Typography>
                                    </label>
                                  </Fragment>
                                ) : (
                                  <Fragment>
                                    <Box
                                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                    >
                                      <IconButton onClick={() => setEmailLogo("")}><Close /></IconButton>
                                      <Typography>{emailLogo}</Typography>
                                    </Box>
                                  </Fragment>
                                )}
                              </Box>
                              <FormHelperText sx={{ display: errors?.formImage ? "block" : "none" }} error={errors?.formImage && true}>{errors?.formImage?.message}</FormHelperText>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {!featured && (
                        <Grid item md={12}>
                          <Typography sx={{ mb: 2, fontWeight: 600, textDecoration: "underline" }}>Email Body:</Typography>
                          <Box className="App">
                            <CKEditor
                              editor={ClassicEditor}
                              config={{
                                toolbar: {
                                  items: [
                                    "undo",
                                    "redo", "|",
                                    "heading", "|",
                                    "bold",
                                    "italic",
                                  ]
                                },
                              }}
                              data={ckValue}
                              onBlur={(event, editor) => handleEditorChange(event, editor)}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setCkValue(data);
                              }}
                            />
                          </Box>
                        </Grid>
                      )}
                    </Fragment>
                  )
                )}
                <Grid item md={12}>
                  <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                    <PrimaryButton
                      // fullWidth
                      title={"Submit"}
                      type={"submit"}
                      loading={loading}
                    // onClick={() => bannerImage()}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box >
    </Fragment >
  )
}

export default UploadHomeBanner;